import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { PolicyConsentService } from '@app/services/policy-consent.service';
import { catchError, switchMap, throwError } from 'rxjs';

// Sent from the consent pop-up itself: waiting on that pop-up here would never resolve.
const ACCEPT_POLICIES_PATH = '/users/me/accepted-policies';

/**
 * While the user has policies to accept, the API answers every request with a 403 listing them.
 * Ask for consent and replay the request once accepted, so callers never see the rejection.
 */
export const policyInterceptor: HttpInterceptorFn = (req, next) => {
    const policyConsentService = inject(PolicyConsentService);

    if (req.url.endsWith(ACCEPT_POLICIES_PATH)) return next(req);

    const sentAt = policyConsentService.acceptances;
    return next(req).pipe(
        catchError((error: unknown) => {
            const pendingPolicies = policyConsentService.pendingPoliciesFrom(error);
            if (!pendingPolicies.length) return throwError(() => error);

            return policyConsentService
                .requestConsent(pendingPolicies, sentAt)
                .pipe(switchMap(accepted => (accepted ? next(req) : throwError(() => error))));
        }),
    );
};
